module.exports = __webpack_public_path__ + "img/user-transfer.18156d6d.svg";